"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModelBuilder = void 0;
var lodash_1 = __importDefault(require("lodash"));
var thunderbolt_becky_types_1 = require("@wix/thunderbolt-becky-types");
var componentExtensions_1 = require("../componentExtensions");
var aRenderFlags = function (partialFlags) {
    if (partialFlags === void 0) { partialFlags = {}; }
    return (__assign({ compPreviewState: null, componentViewMode: 'preview', isBackToTopButtonAllowed: false, isExternalNavigationAllowed: false, isPlayingAllowed: false, isSlideShowGalleryClickAllowed: false, isSocialInteractionAllowed: false, renderFixedPositionContainers: false, shouldBlockGoogleMapInteraction: false, shouldResetComponent: false, shouldResetGalleryToOriginalState: false, shouldResetSlideShowNextPrevButtonsPosition: false, shouldResetSubscribeFormMinMaxWidth: false, shouldResetTinyMenuZIndex: false, isComponentTransitionAllowed: false, renderFixedPositionBackgrounds: false }, partialFlags));
};
var getCompInfo = function (_a, deps) {
    var dataOverrides = _a.dataOverrides, structureOverrides = _a.structureOverrides, environment = _a.environment;
    var compInfo = __assign({ compId: structureOverrides.id, compData: dataOverrides.data, compProps: dataOverrides.properties, compDesign: dataOverrides.design, styleProperties: dataOverrides.style.style.properties, uiType: structureOverrides.uiType, compStylableClass: structureOverrides.styleId + "__root", compLayout: structureOverrides.layout, skin: structureOverrides.skin, fullNameCompType: structureOverrides.componentType }, environment);
    return lodash_1.default.pick(compInfo, deps);
};
exports.createModelBuilder = function (customMappers) {
    if (customMappers === void 0) { customMappers = {}; }
    var components = {};
    var carmiData = {};
    var siteColors = [];
    var globalImageQuality = {
        id: 'IMAGE_QUALITY',
        type: 'GLOBAL_IMAGE_QUALITY',
        quality: 1,
        unsharpMask: { amount: 1, radius: 1, threshold: 1 },
    };
    var environment = {
        isMobileView: false,
        language: 'en',
        viewMode: 'desktop',
        deviceType: 'Desktop',
        experiments: {},
        siteColors: siteColors,
        globalImageQuality: globalImageQuality,
        mainPageId: 'c1dmp',
        metaSiteId: '',
        hasResponsiveLayout: false,
        topology: thunderbolt_becky_types_1.aTopology({
            mediaRootUrl: 'https://static.wixstatic.com/',
            staticMediaUrl: 'https://static.wixstatic.com/media',
            staticHTMLComponentUrl: 'someStaticHTMLComponentUrl',
            scriptsUrl: 'https://static.parastorage.com',
        }),
    };
    var build = function (name, compId) {
        var result = lodash_1.default.mapValues(components, function (comp) {
            var compResult = comp.build();
            var allComponentMappers = __assign(__assign({}, componentExtensions_1.componentsMappers), customMappers);
            var compMapper = allComponentMappers[compResult.structureOverrides.componentType][name];
            var compInfo = getCompInfo(__assign(__assign({}, compResult), { environment: environment }), Object.keys(compMapper.deps));
            return compMapper.resolver(__assign(__assign(__assign({}, compInfo), environment), { siteColors: siteColors }), carmiData);
        });
        return compId ? result[compId] : result;
    };
    var builder = {
        addComponent: function (componentBuilder) {
            components[componentBuilder.getId()] = componentBuilder;
            return builder;
        },
        withResponsiveLayout: function () {
            Object.assign(environment, { hasResponsiveLayout: true });
            return builder;
        },
        withTopology: function (topology) {
            if (topology === void 0) { topology = thunderbolt_becky_types_1.aTopology(); }
            Object.assign(environment, { topology: topology });
            return builder;
        },
        withMobileView: function () {
            Object.assign(environment, {
                isMobileView: true,
                viewMode: 'mobile',
                deviceType: 'Smartphone',
            });
            return builder;
        },
        withDesktopView: function () {
            Object.assign(environment, {
                isMobileView: false,
                viewMode: 'desktop',
                deviceType: 'Desktop',
            });
            return builder;
        },
        withDeviceType: function (_a) {
            var deviceType = _a.deviceType;
            Object.assign(environment, { deviceType: deviceType });
            return builder;
        },
        withLanguage: function (language) {
            environment.language = language;
            return builder;
        },
        withExperiments: function (experiments) {
            Object.assign(environment, { experiments: experiments });
            return builder;
        },
        withCarmiData: function (data) {
            carmiData = data;
            return builder;
        },
        withRenderFlags: function (renderFlags) {
            Object.assign(environment, aRenderFlags(renderFlags));
            return builder;
        },
        withSiteColors: function (data) {
            siteColors = data;
            return builder;
        },
        withMetaSiteId: function (metaSiteId) {
            Object.assign(environment, { metaSiteId: metaSiteId });
            return builder;
        },
        buildProps: function (compId) {
            return build('props', compId);
        },
        buildCss: function (compId) {
            return build('css', compId);
        },
        buildSdkData: function (compId) {
            return build('sdkData', compId);
        },
    };
    return builder;
};
//# sourceMappingURL=modelBuilder.js.map